import { ParsleyCreditCardValidator } from './ParsleyCreditCardValidator';
/**
 * Class Parsley helper
 * 
 * Add custom validator for passwords
 */

export default class ParsleyHelper {

    /**
     * Method call custom validators
     *
     * @method addValidators
     * @chainable
     * @public
     */
    static addValidators() {

        this.addCustomPasswordValidator()
            .addCustomDateValidatorMM()
            .addCustomDateValidatorYY()
            .addCustomDateValidatorYYYY()
            .addCustomPhoneValidator()
            .addCustomPostalCodeValidator()
            .addCustomFullNameValidator();
        return this;
    }

    /**
     * Method attaches custom password checking to form instance
     *
     * @method  addCustomPasswordValidator 
     * @chainable
     * @public
     */
    static addCustomPasswordValidator() {
        // create password strength 
        var expression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-!@#\$%\^&\*])(?=.{8,})/;
        var regex = new RegExp(expression);

        // add password validation
        window.Parsley.addValidator('checkPassword', {
            validateString: function(value) {
                return regex.test(value);
            }
        });

        return this;
    }

    /**
     * Method attatches custom MM input checker
     *
     * @method addCustomDateValidatorMM
     * @chainable
     * @public
     */
    static addCustomDateValidatorMM() {
        var expression = /(^0[1-9]|^(10)|^(11)|^(12)){1}$/;
        var regex = new RegExp(expression);

        window.Parsley.addValidator('checkMonth', {
            validateString: function(value) {
                return regex.test(value);
            }
        });

        return this;
    }

    /**
     * Method attatches custom YY input checker
     *
     * @method addCustomDateValidatorYY
     * @chainable
     * @public
     */
    static addCustomDateValidatorYY() {
        var expression = /^([1-9])([0-9])$/;
        var regex = new RegExp(expression);


        window.Parsley.addValidator('checkYear', {
            validateString: function(value) {
                return regex.test(value);
            }
        });

        return this;
    }

    static addCustomDateValidatorYYYY() {
        var expression = /^20([1-9])([0-9])$/;
        var regex = new RegExp(expression);
        var date = new Date();
        var currentFullYear = date.getFullYear();

        window.Parsley.addValidator('checkYearFull', {
            validateString: function(value) {
                return regex.test(value) && parseInt(value) >= currentFullYear;
            }
        });

        return this;
    }

    /**
     * Method attatches custom phone input checker
     *
     * @method addCustomPhoneValidator
     * @chainable
     * @public
     */
    static addCustomPhoneValidator() {
        var expression = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        var regex = new RegExp(expression);

        window.Parsley.addValidator('checkPhone', {
            validateString: function(value) {
                return regex.test(value);
            }
        });

        return this;
    }

    /**
     * Method checks for a full name
     *
     * @method addCustomFullNameValidator
     * @chainable
     * @public
     */
    static addCustomFullNameValidator() {
        var expression = /^(\s){0,}([a-zA-Z]){1,}((\s){1,}([a-zA-Z]){1,}){1,}(\s){0,}$/;
        var regex = new RegExp(expression);

        window.Parsley.addValidator('fullName', {
            validateString: function(value) {
                return regex.test(value);
            }
        });

        return this;
    }

    /**
     * Method attatches custom postal code input checker
     *
     * @method addCustomPosalCodeValidator
     * @chainable
     * @public
     */
    static addCustomPostalCodeValidator() {

        //US format
        var zipCodeExpression = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
        var zipCodeRegex = new RegExp(zipCodeExpression);
        //outside of the US format
        var postalCodeExpression = /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/i;
        var postalCodeRegex = new RegExp(postalCodeExpression);

        window.Parsley.addValidator('checkPostalCode', {
            validateString: function(value) {
                return zipCodeRegex.test(value) || postalCodeRegex.test(value);
            }
        });
        return this;
    }
}